<template>
  <div :class="class" class="mt-6 flex flex-wrap gap-4 items-center justify-between">
    <div class="flex items-center gap-2">
      <template v-if="data">

        <!-- <button
          v-for="(icon, i) in paginationIcons"
          :key="i"
          class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50"
          :disabled="i === 0 || i === 1"
        >
          <component :is="icon" class="h-5 w-5" />
        </button> -->
        <button
          @click="paginate(data.prevPage!)" :disabled="!data.prevPage"
          class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50"
        >
          <ChevronLeftIcon class="h-5 w-5" />
        </button>
  
        <template v-if="data.total">
          <button
           v-if="data.prevPage !== 1 && data.currentPage !== 1" :value="1"
           @click="paginate(1)"
            class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
          >
            1
          </button>
    
          <button
            class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px] border-2 border-zinc-400"
          >
            {{ data.currentPage }}
          </button>
    
          <button
            v-if="data.nextPage"
            @click="paginate(data.nextPage!)"
            class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
          >
            {{ data.nextPage }}
          </button>
    
          <button
            v-if="displayLastPage"
            class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
          >
            ...
          </button>
    
          <button
            v-if="displayNextToLast"
            @click="paginate(data.lastPage - 1)"
            class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
          >
            {{ (data.lastPage - 1) }}
          </button>
    
          <button
            v-if="displayLastPage"
            @click="paginate(data.lastPage)"
            class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
          >
            {{ data.lastPage }}
          </button>
        </template>
  
        <button
          @click="paginate(data.nextPage!)" :disabled="!data.nextPage"
          class="rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50"
        >
          <ChevronRightIcon class="h-5 w-5" />
        </button>
      </template>
    </div>
    <div v-if="selectedPerPage" class="flex items-center gap-4">
      <Select v-model="selectedPerPage">
        <SelectTrigger>
          <SelectValue :placeholder="`${selectedPerPage} por página`" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="10">10 por página</SelectItem>
          <SelectItem value="25">25 por página</SelectItem>
          <SelectItem value="50">50 por página</SelectItem>
        </SelectContent>
      </Select>
      <span class="text-sm text-zinc-400 w-[142px]">
        Página 1 de 1
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/vue/24/outline'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { PaginationData } from '@/interfaces/Pagination'
import { computed } from 'vue'

const paginationIcons = [
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
]

const props = withDefaults(
  defineProps<{ perPage?: string, data?: PaginationData, class?: string }>(), 
  {}
)
const emit = defineEmits<{ (event: 'update:per-page', value: string): void, (event: 'update:page', value: string): void }>()

const selectedPerPage = computed({
  get: () => props.perPage,
  set: (value: string) => emit('update:per-page', value),
})

const displayNextToLast = computed(() => 
  !!(props.data!.lastPage - 1) && 
  (props.data!.lastPage - 1) !== props.data!.nextPage && 
  (props.data!.lastPage - 1) !== props.data!.currentPage && 
  (props.data!.lastPage - 1) !== props.data!.prevPage
)

const displayLastPage = computed(() => 
  props.data!.lastPage !== props.data!.nextPage && 
  props.data!.lastPage !== props.data!.currentPage
)

const paginate = (page: any) => {
  emit('update:page', page)
}
</script>

<style lang="scss" scoped>
button.text-zinc-400 {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>